module.exports = __webpack_public_path__ + "img/squad.f2babbd9.png";